export default "__VITE_ASSET__D5JM9D8I__"